import { ReactNode } from "react";
import ActionMenu from "../DataTable/ActionMenu";
import { ReactComponent as DeactivateIcon } from "../../assets/svg/deactivate.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit.svg";
import { ReactComponent as EyeIcon } from "../../assets/svg/eye.svg";
import Logs from "../../assets/images/logs.png";

export type ActionItem<TValue extends string> = {
  label: string;
  value: TValue;
  icon: ReactNode;
  disabled?: boolean;
};

interface DynamicActionMenuProps<TItem = any, TValue extends string = string> {
  item: TItem;
  isActive: boolean;
  handleChange: (value: TValue, item: TItem) => void;
  actions?: ActionItem<TValue>[];
}

const CustomActionMenu = <TItem, TValue extends string = string>({
  item,
  isActive,
  handleChange,
  actions,
}: DynamicActionMenuProps<TItem, TValue>) => {
  const actionItems = actions
    ? actions
    : isActive
      ? ([
        {
          label: "View",
          value: "view",
          icon: <EyeIcon height={24} width={24} />,
        },
        {
          label: "Edit",
          value: "edit",
          icon: <EditIcon height={24} width={24} />,
        },
        {
          label: "Logs",
          value: "logs",
          icon: <img src={Logs} alt="Logs" width={24} />,
        },
        {
          label: "Deactivate",
          value: "deactivate",
          icon: <DeactivateIcon height={24} width={24} />,
        },
      ] as ActionItem<TValue>[])
      : ([
        {
          label: "View",
          value: "view",
          icon: <EyeIcon height={24} width={24} />,
        },
        {
          label: "Logs",
          value: "logs",
          icon: <img src={Logs} alt="Logs" width={24} />,
        },
      ] as ActionItem<TValue>[]);

  return (
    <ActionMenu
      onChange={(value) => handleChange(value as TValue, item)}
      actionItems={actionItems as ActionItem<string>[]}
    />
  );
}

export default CustomActionMenu;
